/**
 * SEO 配置 - 支持多域名
 * 通过环境变量 VUE_APP_SEO_DOMAIN 指定主域名，默认为 newoceanmachine.com（Search Console 主域名）
 * 构建时: BUILD_DOMAIN=www.newoceanmachine.com npm run build
 */
const SEO_DOMAIN = process.env.VUE_APP_SEO_DOMAIN || process.env.BUILD_DOMAIN || 'https://www.newoceanmachine.com';

export default {
  domain: SEO_DOMAIN,
  // 支持的域名列表（用于 sitemap 多域名场景）
  supportedDomains: [
    'https://www.newoceanmachine.com',
    'https://www.newoceanmachines.top'
  ]
};



// WEBPACK FOOTER //
// ./src/config/seo.js